<script setup lang="ts">
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import _ from 'lodash'
import { computed, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'

import {
  FlashOfferDetailActionTypes,
  useFlashOfferDetailStore
} from '@/modules/flashoffer/stores/flashoffer.detail.store.ts'
import ListingDetail from '@/modules/realestate/views/ListingDetail.vue'
import TagCell from '@/onenetwork/components/datatable/TagCell.vue'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import { numHelper } from '@/utils/numHelper.ts'
import moment from 'moment'
import { useConfirm } from 'primevue'
import { useToast } from 'primevue/usetoast'
import { Icon } from '@iconify/vue'
import { FlashOfferAPI } from '../constants/flashoffer.api.uri.const'


const router = useRouter()
const flashOfferDetailStore = useFlashOfferDetailStore()
const id_flash_offer = router.currentRoute.value.params.id


const pageTabs = computed(() => {
  return flashOfferDetailStore.tabs
})
const displayTabContent = computed(() => {
  return flashOfferDetailStore.tabs?.find(tab => tab.active)?.id || 'list'
})
const TableConfig = computed(() => {
  return flashOfferDetailStore.tableConfig
})
const filter = computed(() => {
  return flashOfferDetailStore.filter
})
const loading = computed(() => {
  return flashOfferDetailStore.action_type == FlashOfferDetailActionTypes.FETCHING
})
const page = computed(() => {
  return flashOfferDetailStore.page
})
const pageSize = computed(() => {
  return flashOfferDetailStore.pageSize
})
const dataSource = computed(() => {
  return flashOfferDetailStore.data
})

const canEditItem = computed(() => {
  return false
})

const canStopFlashOffer = computed(() => {
  return flashOfferDetailStore.detail?.status === 'ongoing' || flashOfferDetailStore.detail?.status === 'coming_soon'
})

const handleChangeTab = (tab: any) => {

  flashOfferDetailStore.changeTab(tab.id)
}

const handleCloseTab = (tab: any) => {

  flashOfferDetailStore.closeTab(tab.id)
}

const handleCloseAllTab = () => {
  flashOfferDetailStore.closeAllTab()
}

const handleChangePage = (page: number) => {

  flashOfferDetailStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  flashOfferDetailStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {

  flashOfferDetailStore.setFilter(filter)
}


const handleChangeSelectedRow = (ids: Array<string|number>) => {

}

const handleSort = (field: string, direction: string) => {

  flashOfferDetailStore.toggleSort(field, direction)
}

const requestFetchFODetail = _.debounce(async () => {
  try{
    const res = await flashOfferDetailStore.fetchDetail(id_flash_offer as string)
  } catch (e) {

  }
}, 500)



const toast = useToast();
const initialValues = computed(() => flashOfferDetailStore.detail);
const confirm = useConfirm()
const loadingStopFlashOffer = ref<boolean>(false);
const formRef = ref<any>(null);
const startedAt = computed({
  get: () => moment(initialValues.value?.started_at).toDate(),
  set: (value) => {
    formRef.value?.setFieldValue('started_at', moment(value).format('YYYY-MM-DD HH:mm:ss'));
  }
});

const endedAt = computed({
  get: () => moment(initialValues.value?.ended_at).toDate(),
  set: (value) => {
    formRef.value?.setFieldValue('ended_at', moment(value).format('YYYY-MM-DD HH:mm:ss'));
  }
});

const resolver = (e: any) => {
  const errors: any = {
    user_id: [],
    transaction_code: [],
    amount: [],
    content: []
  };
  return {
    values: e.values,
    errors
  };
};

const onFormSubmit = ({values, valid}: any) => {
  console.log('onFormSubmit', values, valid);
  if(!valid) return;
};

const stopFlashOffer = async () => {
  try{
    loadingStopFlashOffer.value = true;
    const formData = {
      flash_offer_ids: [flashOfferDetailStore.detail?.id],
    }

    const res = await APIClient.post(FlashOfferAPI.flashoffer.stop, formData);
    if (res.data.code === 200) {
      //close modal
      toast.add({ severity: 'success', summary: 'Success', detail: 'Đã dừng Flash Offer', life: 3000 });
      setTimeout(() => {
        loadingStopFlashOffer.value = false;
        router.push({ name: 'flash-offer-list' })
      }, 500);
    }
  } catch (e: any) {
    loadingStopFlashOffer.value = false;
    const errorMessage = e.response?.data?.errors[0]?.error || 'An error occurred';
    toast.add({ severity: 'error', summary: 'Rejected', detail: errorMessage, life: 3000 });
  }
}

const handleStopFlashOffer = () => {
  confirm.require({
    message: 'Bạn có chắc chắn muốn dừng Flash Offer này không?',
    header: 'Xác nhận',
    rejectProps: {
      label: 'Huỷ',
      severity: 'secondary',
      outlined: true
    },
    acceptProps: {
      label: 'Đồng ý'
    },
    accept: () => stopFlashOffer(),
  });
}

watch(()=> flashOfferDetailStore.uuid, (newVal, oldVal) => {
  requestFetchFODetail()
})

onMounted(() => {
  requestFetchFODetail()
})

</script>

<template>
  <dashboard-layout currentRoute="flash-offer/list" page-title="Quản lý Flash Offer • Chi tiết" :tabs="pageTabs" :tabsEvent="{
    close: handleCloseTab,
    select: handleChangeTab,
    closeAll: handleCloseAllTab
  }">
    <template v-if="displayTabContent == 'list'">
      <Form
          v-slot="$form"
          ref="formRef"
          :initial-values="initialValues"
          :resolver="resolver"
          @submit="onFormSubmit">
        <Panel class="mb-5" header="Cài đặt Flash Offer">
          <div class="flex justify-between items-center">
            <div class="flex flex-col md:flex-row items-start gap-x-10 gap-y-5">
            <InputText name="province_id" hidden type="text" class="form-control"/>
            <InputText name="district_id" hidden type="text" class="form-control"/>
            <InputText name="real_estate_ids" hidden type="text" class="form-control"/>
            <div class="flex flex-col gap-1">
              <label class="form-label">Thời gian bắt đầu</label>
              <div class="input">
                <!-- <DatePicker :manual-input="true" :disabled="!canEditItem" :default-value="moment(`2025-05-01 08:00:00`).toDate()" class="form-control" show-time/> -->
                <DatePicker :manual-input="true" v-model="startedAt" :disabled="!canEditItem"  class="form-control w-full" show-time/>
              </div>
            </div>
            <div class="flex flex-col gap-1">
              <label class="form-label">Thời gian kết thúc</label>
              <div class="input">
                <!-- <DatePicker :manual-input="true" :disabled="!canEditItem" :default-value="moment(`2025-05-01 08:00:00`).toDate()" class="form-control" show-time/> -->
                <DatePicker :manual-input="true" v-model="endedAt" :disabled="!canEditItem" class="form-control w-full" show-time/>
              </div>
            </div>
            <div class="flex flex-col gap-1 min-w-[320px]">
              <label class="form-label">Tiêu đề sự kiện</label>
              <div class="input">
                <InputText :disabled="!canEditItem" name="name" type="text" class="form-control"/>
              </div>
            </div>
            <div class="flex flex-col gap-1">
              <label class="form-label">Tiền cọc</label>
              <div class="input">
                <InputNumber name="deposit" class="form-control w-full" :disabled="!canEditItem" inputId="minmax-buttons" suffix=" đ" mode="decimal" locale="vi-VN" :min="0" :max="10000000000000" fluid />
                  <span class="font-italic text-[12px] text-red-500 mt-1">{{numHelper($form?.deposit?.value).numberToVietnameseText({unit: 'đồng'})}}</span>
                  <span class="italic text-[12px] text-red-500 mt-1" v-if="$form.deposit?.invalid">
                    {{ $form.deposit.error.message }}
                  </span>
              </div>
            </div>
            <div class="flex flex-col gap-1">
              <label class="form-label">Trạng thái</label>
              <TagCell :data="initialValues.status_arr" :cellConfig="{}" />
            </div>
          </div>
          <div class="flex flex-col gap-1" v-if="canStopFlashOffer">
            <label class="form-label">&nbsp;</label>
            <div class="input">
              <button @click="handleStopFlashOffer" :disabled="loadingStopFlashOffer"
                  type="button"
                  :class="['btn flex items-center gap-2', loadingStopFlashOffer ? 'btn-disabled' : 'btn-danger']">
                  <div :class="[loadingStopFlashOffer ? 'flex items-center gap-2' : '']">
                    Dừng Flash Offer <Icon icon="eos-icons:three-dots-loading" width="24" height="24" v-if="loadingStopFlashOffer" />
                  </div>
                </button>
            </div>
          </div>
          </div>

        </Panel>
        <Panel class="mb-5" header="Danh sách sản phẩm mở bán">
            <filter-list
              :read-only="!canEditItem"
              :filter="filter"
              :disable-reset="true"
              :selected-region="initialValues?.province_id"
              :selected-district="initialValues?.district_id"
              @update:filter="handleUpdateFilter"
              :errors="{
                province_id: $form?.province_id?.error?.message,
                district_id: $form?.district_id?.error?.message
              }"
            />
            <data-table
              :loading="loading"
              :tableConfig="TableConfig"
              :displayConfig="false"
              :page-size="pageSize"
              :page="page"
              :total-page="dataSource?.totalPage || 0"
              :total-records="dataSource?.totalRecords || 0"
              :data="dataSource?.list || []"
              :row-action-buttons="[
                // { action: handleGotoDetail, css: 'btn btn-cs', label: 'Chi tiết', icon: 'iconamoon:edit-duotone' }
              ]"
              @page-changed="handleChangePage"
              @pagesize-changed="handleChangePageSize"
              @toggle-visibility="flashOfferDetailStore.toggleColumnVisibility"
              @on-selected-row="handleChangeSelectedRow"
              @on-sort="handleSort"

            />

        </Panel>
      </Form>
    </template>
    <template v-else>
      <template v-for="tab in pageTabs">
        <template v-if="tab.id == displayTabContent">
          <ListingDetail :id="tab.id" :key="tab.id"/>
        </template>
      </template>
    </template>
  </dashboard-layout>
</template>

<style scoped></style>
